import React from 'react';

export default class ErrorBoundary extends React.Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error('ui_crash', error, info); }
  reset = () => this.setState({ error: null });
  render() {
    if (this.state.error) {
      return (
        <div className="card m-4 border-rose-500/40 bg-rose-500/10 p-4 text-sm text-rose-100">
          <div className="font-semibold">Something went wrong.</div>
          <pre className="mt-1 whitespace-pre-wrap text-xs opacity-80">{String(this.state.error)}</pre>
          <button className="btn-ghost mt-3" onClick={this.reset}>Reset</button>
        </div>
      );
    }
    return this.props.children;
  }
}
